const DataRetentionPolicy = () => {
  return (
    <div className="overflow-hidden">
      <section className="relative py-24 hero-gradient mesh-gradient">
        <div className="absolute top-20 right-10 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold font-['Outfit'] tracking-tighter mb-6">
              Data Retention Policy
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Jnan Innovative IT Solutions retains customer and business information only for as long as necessary to provide services, comply with contractual obligations, and meet legal or operational requirements.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            <p>
              Jnan Innovative IT Solutions retains customer and business information only for as long as necessary to provide services, comply with contractual obligations, and meet legal or operational requirements.
            </p>

            <h2>1. Retention Period</h2>
            <ul>
              <li>Order and fulfillment records may be retained for operational and accounting purposes.</li>
              <li>Audit logs are retained according to business and security requirements.</li>
              <li>Customer information is retained only as required to support integrations and customer operations.</li>
              <li>Amazon customer PII is retained only for the approved purpose and deleted no later than 30 days after order delivery unless a longer retention period is legally required.</li>
              <li>Audit logs for systems handling Amazon data are retained for at least 12 months.</li>
            </ul>
            <br />

            <h2>2. Processing Records</h2>
            <p>
              For Amazon SP-API data, retention records identify the data fields processed, source API/report, business purpose, storage location, access roles, retention period, and deletion method.
            </p>
            <br />

            <h2>3. Data Disposal</h2>
            <p>
              When information is no longer required, it is securely deleted or destroyed in accordance with internal procedures.
            </p>
            <br />

            <p>
              Access to retained data is restricted to authorized personnel only.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataRetentionPolicy;
